export const preventInteraction = (accordion) => {
    if (accordion?.classList.contains('no-access')) {
        accordion.addEventListener('click', (e) => {
            e.preventDefault()
        })
    }
}